import { useMutationState } from '@tanstack/react-query'
import { useNavigation } from 'react-router-dom'
import { useLoadingStore } from '@/stores/useLoadingStore'
import { useEffect, useId } from 'react'

const LoadingOverlay = ({ isPrioritiPending }: { isPrioritiPending?: boolean }) => {
  const navigation = useNavigation()

  // Get all active mutations to check their meta
  const mutations = useMutationState({
    filters: { status: 'pending' },
    select: (mutation) => mutation.state.status === 'pending' && !mutation.options.meta?.silent
  })

  // Count only non-silent mutations
  const isMutating = mutations.filter(Boolean).length

  const addRequest = useLoadingStore((state) => state.addRequest)
  const removeRequest = useLoadingStore((state) => state.removeRequest)
  const requestIds = useLoadingStore((state) => state.requestIds)

  const id = useId()

  // Sync local loading state to global store
  useEffect(() => {
    if (typeof isPrioritiPending !== 'undefined') {
      if (isPrioritiPending) {
        addRequest(id)
      } else {
        removeRequest(id)
      }
    }

    return () => {
      if (typeof isPrioritiPending !== 'undefined') {
        removeRequest(id)
      }
    }
  }, [isPrioritiPending, addRequest, removeRequest, id])

  // If this is a local instance (acting as a trigger), do not render anything
  if (typeof isPrioritiPending !== 'undefined') {
    return null
  }

  // Global instance logic
  const isGlobalLoading = requestIds.length > 0
  const isLoading = isMutating > 0 || isGlobalLoading || navigation.state === 'loading'

  return (
    <div
      data-loading-overlay
      className={`fixed inset-0 flex items-center justify-center z-50 transition-opacity duration-300 bg-black/20
                  ${isLoading ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
    >
      <div className='flex items-center justify-center p-8'>
        <div className='flex items-center justify-center h-screen'>
          <div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary'></div>
        </div>
      </div>
    </div>
  )
}

export default LoadingOverlay
